import { render } from "./BaseButton.vue?vue&type=template&id=65ec026c&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=65ec026c&scoped=true&lang=css"

import exportComponent from "C:\\www\\mutual-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ec026c"]])

export default __exports__